import React, { useRef, useEffect } from 'react';
import { Scope } from './style';

const Circle = ({ diametre, top, left }) => {
  const tarjet = useRef();
  useEffect(() => {
    tarjet.current.style.top = `${top}px`;
    tarjet.current.style.left = `${left}px`;
    tarjet.current.style.width = `${diametre}px`;
    tarjet.current.style.height = `${diametre}px`;
  }, [top, left, diametre]);
  return (
    <Scope
      className="circle"
      style={{
        width: `${diametre}px`,
        height: `${diametre}px`,
        borderRadius: `${diametre / 2}px`
      }}
      innerRef={tarjet}
    />
  );
};

export default Circle;
